import React from "react";
import sheaButterBanner from "./../../../../../Images/Blog/Shea Butter Hair Spa/Banner.png";

const SheaButterHairSpaImg = () => {
  return (
    <div className="blogImg-content">
      <img src={sheaButterBanner} alt="stepbystepBanner" loading="lazy" />
    </div>
  );
};

export default SheaButterHairSpaImg;
